import { HomeFilled, RollbackOutlined } from '@ant-design/icons';
import { Button, Result, Space } from 'antd';
import { useSession } from 'next-auth/react';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { DEFAULT_FILTERS_PAGE_URL } from '../../constants/appUrls';
import { roles, userRolesMap } from '../../model/types';
import { isAdmin, isAdminOrAgent, isEndUser } from '../../utils/accountHelper';
import { redirectTo } from '../../utils/routeHelper';
/**
 * @param  - `role` is the required role to see the children of this component
 */
export default function AuthorizationGate({ children, role }: PropsWithChildren<{ role: roles }>) {
    const { t } = useTranslation('error');
    const { data: session } = useSession();
    const isVisibleToUser = checkAuthorizationBySession(role, session.userInfo.rls[0]);

    if (!isVisibleToUser) {
        return (
            <div style={{ height: '100vh', alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                <Result
                    status="403"
                    title="403"
                    subTitle="Sorry, you are not authorized to access this page."
                    extra={
                        <Space>
                            <Button type="primary" onClick={() => window.history.back()} icon={<RollbackOutlined />}>
                                {t('button.back')}
                            </Button>
                            <Button
                                type="primary"
                                onClick={() => redirectTo(DEFAULT_FILTERS_PAGE_URL)}
                                icon={<HomeFilled />}
                            >
                                Home
                            </Button>
                        </Space>
                    }
                />
            </div>
        );
    }

    return <>{children}</>;
}

function checkAuthorizationBySession(authorizatedRole: roles, currentUserRole: roles) {
    switch (authorizatedRole) {
        case userRolesMap.ROLE_ADMIN:
            return isAdmin(currentUserRole);
        case userRolesMap.ROLE_AGENT:
            return isAdminOrAgent(currentUserRole);
        case userRolesMap.ROLE_END_USER:
            return isEndUser(currentUserRole);
        default:
            return false;
    }
}
